//--------------------------------------------------
// Video

function getEmbedUrl(
    url,
    shouldAutoplay,
    shouldMute,
    shouldShowCaptions,
    shouldPreload,
) {
    if (!url) {
        return '';
    }

    if (url.includes('vimeo')) {
        let vimeoId = url.split('vimeo.com/')[1];
        if (!vimeoId) {
            return '';
        }
        [vimeoId] = vimeoId.split(/[/?&]/);

        const vimeoParams = [];
        if (shouldAutoplay) {
            vimeoParams.push('autoplay=1');
        }
        if (shouldMute) {
            vimeoParams.push('muted=1');
        }
        if (shouldShowCaptions) {
            vimeoParams.push('texttrack=en');
        }
        if (shouldPreload) {
            vimeoParams.push('preload=auto');
        }
        if (shouldAutoplay) {
            vimeoParams.push('api=1');
        }

        return `https://player.vimeo.com/video/${vimeoId}${vimeoParams.length ? `?${vimeoParams.join('&')}` : ''}`;
    }

    if (url.includes('youtu')) {
        const youtubeLong = url.split('watch?v=')[1];
        const youtubeShort = url.split('youtu.be/')[1];
        let youtubeId = youtubeLong || youtubeShort;

        if (!youtubeId) {
            return '';
        }

        [youtubeId] = youtubeId.split('&');
        [youtubeId] = youtubeId.split('?');

        const youtubeParams = [];
        if (shouldAutoplay) {
            youtubeParams.push('autoplay=1');
        }
        if (shouldMute) {
            youtubeParams.push('mute=1');
        }
        if (shouldShowCaptions) {
            youtubeParams.push('cc_load_policy=1');
        }
        if (shouldPreload) {
            youtubeParams.push('preload=1');
        }
        if (shouldAutoplay) {
            youtubeParams.push('enablejsapi=1');
        }

        return `https://www.youtube.com/embed/${youtubeId}${
            youtubeParams.length ? `?${youtubeParams.join('&')}` : ''
        }`;
    }

    return '';
}

function postIframeCommand(iframe, url, action) {
    if (!(iframe instanceof HTMLIFrameElement) || !iframe.contentWindow) {
        return;
    }

    if (url.includes('youtu')) {
        iframe.contentWindow.postMessage(
            JSON.stringify({
                event: 'command',
                func: action === 'play' ? 'playVideo' : 'pauseVideo',
                args: [],
            }),
            '*',
        );
        return;
    }

    if (url.includes('vimeo')) {
        iframe.contentWindow.postMessage(
            JSON.stringify({
                method: action,
            }),
            '*',
        );
    }
}

function initVideos() {
    if (!document.querySelector('.video, video-embed')) {
        return;
    }

    const videoEmbeds = document.querySelectorAll('video-embed');
    if (!videoEmbeds.length) {
        return;
    }

    const autoplayEmbeds = document.querySelectorAll(
        'video-embed[data-autoplay="1"]',
    );

    if (autoplayEmbeds.length && 'IntersectionObserver' in window) {
        const autoplayObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const embed = entry.target;
                    const button = embed.querySelector('button[data-videourl]');
                    const video = button
                        ? button.previousElementSibling
                        : embed.querySelector('iframe, video');

                    if (!button || !video) {
                        return;
                    }

                    const url = button.dataset.videourl;
                    if (!url) {
                        return;
                    }

                    if (entry.isIntersecting) {
                        const autoplayUrl = getEmbedUrl(
                            url,
                            true,
                            true,
                            true,
                            true,
                        );

                        if (video.nodeName.toLowerCase() === 'iframe') {
                            if (autoplayUrl && video.src !== autoplayUrl) {
                                video.src = autoplayUrl;
                            } else {
                                postIframeCommand(video, url, 'play');
                            }
                        }

                        if (video.nodeName.toLowerCase() === 'video') {
                            video.preload = 'auto';
                            video.muted = true;
                            if (video.textTracks && video.textTracks.length) {
                                Array.from(video.textTracks).forEach(
                                    (trackItem) => {
                                        const track = trackItem;
                                        track.mode = 'showing';
                                    },
                                );
                            }
                            video.play().catch(() => {});
                        }
                        return;
                    }

                    if (video.nodeName.toLowerCase() === 'video') {
                        video.pause();
                    } else {
                        postIframeCommand(video, url, 'pause');
                    }
                });
            },
            {
                threshold: 0.5,
            },
        );

        autoplayEmbeds.forEach((embed) => {
            autoplayObserver.observe(embed);
        });
    }

    document.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) {
            return;
        }

        const button = event.target.closest('video-embed button');
        if (!button) {
            return;
        }

        event.preventDefault();

        const embed = button.closest('video-embed');
        if (!embed || embed.dataset.autoplay === '1') {
            return;
        }

        const url = button.dataset.videourl;
        const video = button.previousElementSibling;
        const embedUrl = getEmbedUrl(url, true, false, false, false);

        if (video && embedUrl) {
            video.src = embedUrl;
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideos);
} else {
    initVideos();
}
